import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { BottomOutsideTitleCard } from '../../Cards';
import { Section } from '../../Section';
import { breakPointsSet1 } from '../../Carousel';
import { Tiles } from '../../Tiles';
export var StorefrontsCarousel = function StorefrontsCarousel(_ref) {
  var storefronts = _ref.storefronts,
    _ref$withSubtitle = _ref.withSubtitle,
    withSubtitle = _ref$withSubtitle === void 0 ? true : _ref$withSubtitle,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? true : _ref$bottomMargin;
  return React.createElement(Section, {
    title: "Encuentra productos en los que invertir agrupados por tus intereses",
    subtitle: "Selecciones tem\xE1ticas de productos financieros para que puedas elegir mejor",
    bottomMargin: bottomMargin
  }, React.createElement(Tiles, {
    breakpoints: breakPointsSet1
  }, storefronts.map(function (storefront, index) {
    return React.createElement(BottomOutsideTitleCard, {
      key: index,
      backgroundImage: storefront.image,
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      link: "".concat(getSuperPartnerBaseURL(), "/invertir/").concat(storefront.alias),
      title: storefront.name,
      subtitle: withSubtitle ? storefront.summary : null
    });
  })));
};